import React from 'react';
import LoadingSpinner from 'v2/common/LoadingSpinner/LoadingSpinner';
import { useStrapiUser } from 'v2/queries';
import { getUserFullName } from 'v2/utils';
import { LinkedEntityType } from '../../../../enums';
import { ActivityTitleProps } from '../../../../types';
import { getLinkedEntityType } from '../../../../utils';
import {
  ContactLinkCreatedTitle,
  DatasetLinkCreatedTitle,
  DataVendorLinkCreatedTitle,
} from './components';

export function LinkCreatedActivityTitle({ activity }: ActivityTitleProps) {
  const { data: user, isSuccess: isUserSuccess } = useStrapiUser({
    id: activity.creator,
  });

  const linkedEntityType = getLinkedEntityType(activity);
  if (linkedEntityType === null) return null;

  if (!isUserSuccess || !user) {
    return <LoadingSpinner />;
  }

  const userFullName = getUserFullName(user);

  switch (linkedEntityType) {
    case LinkedEntityType.DATA_VENDOR:
      return <DataVendorLinkCreatedTitle username={userFullName} />;

    case LinkedEntityType.CONTACT:
      return <ContactLinkCreatedTitle username={userFullName} />;

    case LinkedEntityType.DATASET:
      return <DatasetLinkCreatedTitle username={userFullName} />;

    default:
      return null;
  }
}
